"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pharaonic = void 0;
var jquery_1 = __importDefault(require("jquery"));
require("select2");
// -----------------------------
// Pharaonic.Select2
// -----------------------------
exports.Pharaonic = {
    Select2: {
        clear: function () {
            var $el = (0, jquery_1.default)(this);
            $el.val(null).trigger("change");
        },
        set: function (value) {
            var $el = (0, jquery_1.default)(this);
            $el.val(value).trigger("change");
        },
        value: function () {
            var $el = (0, jquery_1.default)(this);
            return $el.val();
        },
        init: function () {
            // Initialize all select2 elements that haven't been initialized yet
            (0, jquery_1.default)("select.select2:not([data-pharaonic-init])").each(function () {
                var _a, _b, _c;
                var $el = (0, jquery_1.default)(this);
                if (!$el.find('option[value=""]').length) {
                    $el.prepend('<option value=""></option>');
                }
                // Find Livewire component if any
                var component = (_a = $el.closest("[wire\\:id]").attr("wire:id")) !== null && _a !== void 0 ? _a : null;
                var opts = {
                    multiple: $el.is("[multiple]"),
                    tags: $el.is("[data-tags]"),
                    placeholder: (_b = $el.data("placeholder")) !== null && _b !== void 0 ? _b : "Select an option",
                    language: (_c = $el.data("language")) !== null && _c !== void 0 ? _c : "en",
                    dir: $el.data("dir") === "rtl" ? "rtl" : "ltr",
                    minimumResultsForSearch: $el.is("[data-search-off]")
                        ? -1
                        : 0,
                    allowClear: $el.is("[data-clear]"),
                    width: "resolve",
                };
                $el.select2(opts);
                $el.attr("data-pharaonic-init", "true");
                // Wire:model integration
                var modelAttr = $el.attr("wire:model") || $el.attr("wire:model.defer");
                if (component && modelAttr) {
                    var isDeferred_1 = $el.attr("wire:model.defer") !== undefined;
                    if (!$el.data("pharaonic-listener")) {
                        $el.on("change", function () {
                            var val = $el.val();
                            window.livewire
                                .find(component)
                                .set(modelAttr, val, isDeferred_1);
                        });
                        $el.data("pharaonic-listener", true);
                    }
                }
            });
        },
    },
};
// -----------------------------
// Initialize on DOM ready and Livewire updates
// -----------------------------
(0, jquery_1.default)(function () {
    exports.Pharaonic.Select2.init();
});
document.addEventListener("livewire:update", function () {
    exports.Pharaonic.Select2.init();
});
document.addEventListener("livewire:load", function (event) {
    window.livewire.hook("message.processed", function (message, component) {
        exports.Pharaonic.Select2.init();
    });
});
